import { ScheduleTextReminderDay, ScheduleTextReminderMode } from '../types';

export const WEEKDAY_NAMES = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export function defaultTextReminderDays(): ScheduleTextReminderDay[] {
  return WEEKDAY_NAMES.map((dayName, index) => ({
    dayOfWeek: index + 1,
    dayName,
    mode: 'None',
    extraDays: 0,
  }));
}

export function applyTextReminderMode(
  day: ScheduleTextReminderDay,
  mode: ScheduleTextReminderMode
): ScheduleTextReminderDay {
  return {
    ...day,
    mode,
    extraDays: mode === 'SameDayPlus' ? Math.max(1, day.extraDays || 1) : 0,
  };
}
